var _style, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImportImage = function SvgImportImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 64 64"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{display:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 .1h-5.6c-3 1.8-8.4 3.8-12.1 3.8-3.7 0-8.7-2-11.7-3.8h-5.1c-3 2-7.8 4-11.7 4-3.9 0-9.1-2.1-12.1-4H.2v5.5C2 8.5 3 11.2 3 14.9c0 3.7-1 6.9-2.8 9.9v14.9C2 42.6 3 45.5 3 49.2S2 55.6.2 58.5V64h5.6c3-1.8 8.4-3.8 12.1-3.8 3.7 0 8.7 2 11.7 3.8h5.1c3-2 7.8-4 11.7-4s9.1 2.1 12.1 4H64v-5.5c-1.8-2.9-2.8-5.6-2.8-9.3 0-3.7 1-6.9 2.8-9.9V24.5c-1.8-2.9-2.8-5.9-2.8-9.6 0-3.7 1-6.4 2.8-9.3V.1zM52.8 52.6H11.4V11.5h41.4v41.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 41.6a11.2 11.2 0 0 1-5.7-14.9c2.5-5.6 9.1-8.2 14.8-5.8a10.18 10.18 0 0 0-2.5 19.4 8 8 0 0 0 3.3.8c-2.9 1.7-6.6 2-9.9.5z"
  })));
};

export default SvgImportImage;